export default __webpack_public_path__ + "static/media/investira_biz.6d493c5c.svg";